import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  ADMIN_DETAILS,
  ADD_CONSERVATION,
  EDIT_OBJECT,
  EDIT_PHOTOGRAPHY,
  LIST_OBJECT,
  HOME_URL,
  ADMIN_DETAIL,
} from "../../constants/routers";
import { CiEdit } from "react-icons/ci";
import { RiDeleteBin6Line } from "react-icons/ri";
import Tooltip from "@mui/material/Tooltip";
import { IoEye } from "react-icons/io5";
import star from "../../assets/images/category/star.png";
import dummyImage from "../../assets/images/common/nefos.png";
import Modal from "react-bootstrap/Modal";
import Loader from "../../components/common/Common/Loader";
import {
  assignUser,
  createGlb,
  createObject,
  DeleteObject,
  objectConservationCreation,
  objectConservationStatus,
  objectTableEditHandler,
} from "../../api/actions/object";
import toast from "react-hot-toast";
import dummyPro from "../../assets/images/common/profile-logo.png";
import { RiVipCrownFill } from "react-icons/ri";
import { checkPermission } from "../../helpers/permissions";
import { localDataStore } from "../../components/common/Common/localDataStore";
import Select from "react-select";
import Drawer from "react-modern-drawer";
import ObjectAdd from "../../pages/object-management/objectAdd";
import {
  clearAutoSavedFromIndexedDB,
  getAutoSavedFromIndexedDB,
} from "../../indexdb/autosaveIndex";
import { useSaving } from "../../store/SavinContext";
import Objectconsadd from "../ObjectConservation/objectconsadd";
import Objectphotographydetails from "../objectPhotography/Objectphotographydetails";
import { saveModuleState } from "../../indexdb/scrollFreezeIndex";
import { RxOpenInNewWindow } from "react-icons/rx";

const TransitObjectTable = ({
  count,
  setJustSearched,
  justSearched,
  setReachBottom,
  reachBottom,
  setShowLoader,
  showLoader,
  scrollComplete,
  setScrollComplete,
  fetchObjectList,
  hasMore,
  setData,
  search,
  selectedContents,
  formik,
  setOrder,
  order,
  sortBy,
  setSortBy,
  admin,
  conservation = false,
  photography = false,
  setSelectedOption,
  selectedOption,
  checkedRowHandler,
  page,
  showGrid,
  showTable,
  setShowGrid,
  setShowTable,
  data,
  setPage,
  limit,
  setLimit,
  update,
  setUpdate,
  totalRows,
  pending,
  selectProps,
  handleRowSelected,
  isSwal,
  setIsSwal,
  setSelectedRows,
  handleSerialNumber,
}) => {
  const [showDate, setShowDate] = useState();
  const [driveChange, setDriveChange] = useState(null);
  const [conditionChange, setConditionChange] = useState(null);
  const [isAutoObjectList, setIsAutoObjectList] = useState(false);
  const navigate = useNavigate();
  const deleteHandler = (deleteId) => {
    DeleteObject({ id: [deleteId] })((response) => {
      if (response?.status) {
        toast.success("Object deleted successfully");
        setUpdate(!update);
      }
    });
  };
  const [showObjectdetail, setShowObjectDetail] = useState({
    show: false,
    id: "",
    collection: false,
    digital: false,
    conservation: false,
  });
  const [showDetail, setShowDetail] = useState(false);
  const [details, setDetails] = useState();
  const [detailImage, setDetailImage] = React.useState();
  const [detaildescr, setDetaildescr] = React.useState();
  const [selectedScrollTop, setSelectedScrollTop] = useState();
  const userData = JSON.parse(localStorage.getItem("user_info"));
  const location = useLocation();
  const { setIsSaving } = useSaving();
  // const MODULE_KEY = "object_pin_list";

  const queueDatatableCustomStyles = {
    style: {
      borderRadius: "8px",
    },
    headCells: {
      style: {
        backgroundColor: "#D7E2F3",
        color: "#000000",

        fontWeight: "600",
        fontSize: "14px",
        paddingLeft: "15px",
      },
    },
    cells: {
      style: {
        fontSize: "12px",
        fontWeight: "500",
        paddingTop: "12px",
        paddingBottom: "12px",
        paddingLeft: "10px",
      },
    },
  };

  const objectListTableFilterData = {
    sort_by: sortBy,
    search: search,
    order: order,
    collection_completed: conservation && "True",
    page: page,
    limit: limit,
    museum_id: userData.museum,
    is_information_pending: selectedOption === "catlog" ? true : false,
    conservation_status:
      (selectedOption === "conservation_is_draft" &&
        "in_conditional_assessment") ||
      (selectedOption === "completed" && "in_conservation"),
    collection_is_draft: selectedOption === "Drafts" && true,
    is_iconic:
      selectedOption === "Iconic object"
        ? true
        : false || formik?.values?.is_iconic,
    is_image: formik?.values?.is_image,
    material: formik?.values?.material_id,
    category: formik?.values?.category_id,
    height_max: formik?.values?.height_max,
    height_min: formik?.values?.height_min,
    width_max: formik?.values?.width_max,
    width_min: formik?.values?.width_min,
    depth_max: formik?.values?.depth_max,
    depth_min: formik?.values?.depth_min,
    period_start: formik?.values?.period_start,
    period_end: formik?.values?.period_end,
    room: formik?.values?.room,
    acquisition_method: formik?.values?.acquisition_method,
    created_by: formik?.values?.created_by,
    start_date: formik?.values?.start_date,
    end_date: formik?.values?.end_date,
    is_drive_link: "",
    modified_start_date: formik?.values?.modified_start_date,
    modified_end_date: formik?.values?.modified_end_date,
    tags: formik?.values?.tags,
    conservation_grade: formik?.values?.conservation_grade,
    is_emergency: formik?.values?.is_emergency,
    object_assigned: formik?.values?.object_assigned,
    period: formik?.values?.period,
    primary_category: formik?.values?.primary_category,
    is_pinned: true,
  };

  const showHandler = (value, e) => {
    setShowDate(value?.created_date);
    setShowDetail(true);
    setDetailImage(value?.reference_image);
    setDetaildescr(value?.historical_description);
    setDetails(value);
  };

  const hideHandler = () => {
    setShowDetail(false);
  };

  const onEditRedirectHandler = (row) => {
    localDataStore(search, selectedContents, formik, true, "objectPin");

    if (checkPermission("collection_change_object")) {
      navigate(
        `/${
          userData.museum_name
            ? userData?.museum_name?.split(" ").join("_")
            : "Nefos"
        }/${EDIT_OBJECT}/${row?.id}`,
        {
          state: {
            fromPin: true,
            objectListFormik: objectListTableFilterData,
          },
        }
      );
    } else if (checkPermission("photogrophy_change_object")) {
      navigate(
        `/${
          userData.museum_name
            ? userData?.museum_name?.split(" ").join("_")
            : "Nefos"
        }/${EDIT_PHOTOGRAPHY}/${row?.id}`,
        {
          state: {
            fromPin: true,
            objectListFormik: objectListTableFilterData,
          },
        }
      );
    } else if (checkPermission("conservation_change_object")) {
      navigate(
        `/${
          userData.museum_name
            ? userData?.museum_name?.split(" ").join("_")
            : "Nefos"
        }/${ADD_CONSERVATION}/${row?.id}`,
        {
          state: {
            fromPin: true,
            objectListFormik: objectListTableFilterData,
          },
        }
      );
    } else {
      navigate(
        `/${
          userData.museum_name
            ? userData?.museum_name?.split(" ").join("_")
            : "Nefos"
        }/${ADMIN_DETAIL}/${row?.id}`,
        {
          state: {
            fromPin: true,
            objectListFormik: objectListTableFilterData,
          },
        }
      );
    }
  };

  const onBlurHandler = (rowIndex, row, type) => {
    if (type === "condition") {
      setData((prevData) =>
        prevData.map((item) => ({
          ...item,
          is_edit_condition: false,
        }))
      );
      if (conditionChange) {
        objectTableEditHandler(conditionChange)((response) => {
          if (response?.status) {
            setDriveChange(null);
          }
        });
      }
    } else {
      setData((prevData) =>
        prevData.map((item) => ({
          ...item,
          is_edit_drive: false,
        }))
      );
      if (driveChange) {
        objectTableEditHandler(driveChange)((response) => {
          if (response?.status) {
            setDriveChange(null);
          }
        });
      }
    }
  };

  const doubleClickHandler = (e, rowIndex, type) => {
    const newUpdateList = [...data];

    if (type === "Condition") {
      newUpdateList[rowIndex].is_edit_condition = true;
      setData(newUpdateList);
    } else {
      newUpdateList[rowIndex].is_edit_drive = true;
      setData(newUpdateList);
    }
  };

  const onConditionChangeHandler = (e, rowIndex, row) => {
    const dataList = [...data];

    if (e?.label === "Emergency") {
      dataList[rowIndex].is_emergency = true;
      dataList[rowIndex].stability = "";
      setData(dataList);
      const driveData = {
        id: row?.id,
        is_emergency: true,
        stability: "",
      };
      setConditionChange(driveData);
    } else {
      dataList[rowIndex].stability = e?.label;
      dataList[rowIndex].is_emergency = false;
      setData(dataList);
      const driveData = {
        id: row?.id,
        stability: e?.label,
        is_emergency: false,
      };
      setConditionChange(driveData);
    }
  };

  const columns = [
    {
      name: "Object ",
      key: "object_name",
      selector: (row) => row?.object_name,
      cell: (row) => (
        <div style={{ position: "relative", width: "100%" }}>
          <div className="category-name" style={{ cursor: "pointer" }}>
            <div onClick={() => {}} className="d-flex align-items-center">
              <div className="star-img">
                {" "}
                {row?.iconic_object && (
                  <RiVipCrownFill color="gold" style={{ fontSize: "17px" }} />
                )}
              </div>

              {row?.reference_image ? (
                <img
                  className={row?.reference_image ? "thumb-img" : "error-img"}
                  src={row?.reference_image}
                  onError={(e) => (e.currentTarget.src = dummyImage)}
                  alt="ref-img"
                />
              ) : (
                <img className="error-img" src={dummyImage} alt="ref-img" />
              )}
              <div>
                <p style={{ maxWidth: "286px" }}>{row?.object_name}</p>
                <span style={{ color: "gray", fontSize: "12px" }}>
                  {row?.accession_number}
                </span>
              </div>
            </div>
          </div>
        </div>
      ),
      sortable: true,
      grow: 2,
      minWidth: "410px",
      paddingLeft: "15px",
      reorder: false,
    },
    {
      name: "Category",
      key: "category__category_name",
      selector: (row) => row?.category_name,
      cell: (row) => {
        return (
          <div style={{ display: "flex", alignItems: "center" }}>
            <div className="star-img" style={{ width: "28px" }}>
              {" "}
              {row?.key_category === "True" && (
                <img
                  style={{ height: "18px" }}
                  src={star}
                  className="me-2"
                  alt="crown"
                />
              )}
            </div>

            <p>
              {row.prime_category_name && row.category_name
                ? `${row.prime_category_name}-${row.category_name}`
                : row.prime_category_name || row.category_name || ""}
            </p>
          </div>
        );
      },
      sortable: true,
      minWidth: "180px",
    },
    {
      name: "Material",
      key: "material__material_name",
      selector: (row) => row?.material_name,
      cell: (row) => (
        <div style={{ display: "flex" }}>
          <div>
            {row?.material?.slice(0, 2)?.map((li, index, arr) => (
              <p key={index}>
                {li?.material_name}
                {index !== arr.length - 1 && ","}
              </p>
            ))}
          </div>
          {row?.material?.length > 2 && (
            <span
              onClick={() => {
                navigate(
                  `/${
                    userData.museum_name
                      ? userData?.museum_name?.split(" ").join("_")
                      : "Nefos"
                  }/${
                    (photography &&
                      checkPermission(["photogrophy_change_object"]) &&
                      EDIT_PHOTOGRAPHY) ||
                    (conservation &&
                      checkPermission(["conservation_change_object"]) &&
                      ADD_CONSERVATION) ||
                    (checkPermission(["collection_change_object"]) &&
                      location.pathname.split("/")[2] === LIST_OBJECT &&
                      EDIT_OBJECT) ||
                    ADMIN_DETAILS
                  }/${row?.id}`
                );
              }}
              style={{
                display: "flex",
                alignItems: "flex-end",
                color: "blue",
                cursor: "pointer",
                fontSize: "11px",
                marginLeft: "2px",
              }}
            >{`+${row?.material?.length - 2}`}</span>
          )}
        </div>
      ),
      sortable: true,
      minWidth: "180px",
    },
    {
      name: "Condition grade",
      key: "priority",
      selector: (row) => row?.is_emergency || row?.stability,
      cell: (row, rowIndex) => (
        <div
          style={{
            width: "100%",
            height: "100%",
            cursor: "text",
            display: "flex",
          }}
        >
          <div
            onDoubleClick={(e) => doubleClickHandler(e, rowIndex, "Condition")}
            style={{
              width: "100%",
              height: "100%",
              cursor: "text",
              display: "flex",
            }}
          >
            {row?.is_edit_condition ? (
              <Select
                styles={{
                  container: (styles) => ({
                    ...styles,
                    width: "100%",
                  }),
                }}
                onBlur={() => onBlurHandler(rowIndex, row, "condition")}
                onChange={(e) => onConditionChangeHandler(e, rowIndex, row)}
                options={[
                  {
                    value: 1,
                    label: 1,
                  },
                  {
                    value: 2,
                    label: 2,
                  },
                  {
                    value: 3,
                    label: 3,
                  },
                  {
                    value: "Emergency",
                    label: "Emergency",
                  },
                ]}
                value={{
                  value: row?.stability
                    ? row?.stability
                    : row?.is_emergency
                    ? "Emergency"
                    : "",
                  label: row?.stability
                    ? row?.stability
                    : row?.is_emergency
                    ? "Emergency"
                    : "",
                }}
              />
            ) : (
              <Tooltip title="Double click to edit" placement="top-end">
                <p style={{ width: "100%", height: "100%" }}>
                  {row?.stability
                    ? row?.stability
                    : row?.is_emergency
                    ? "Emergency"
                    : ""}
                </p>
              </Tooltip>
            )}
          </div>
        </div>
      ),
      sortable: true,
      minWidth: "180px",
      omit: !conservation,
    },
    {
      name: "Created by",
      key: "created_by__first_name",
      selector: (row) => (row.created_by_name ? row.created_by_name : "Admin"),
      cell: (row) => (
        <div className="created-box">
          <img
            className={row.created_by_thumbnail ? "image" : "error-img"}
            src={row.created_by_thumbnail ? row.created_by_thumbnail : dummyPro}
            alt="dummy-pro"
          />
          {row.created_by_name ? row.created_by_name : "Admin"}
        </div>
      ),
      sortable: true,
      grow: 2,
      width: "180px",
      reorder: false,
    },
    {
      name: "Created at",
      key: "",
      selector: (row) => row?.created_date,
      cell: (row) => {
        return (
          <div className="date-cell">
            <p>{row?.created_date}</p>
          </div>
        );
      },
      sortable: true,
      grow: 2,
      width: "180px",
      reorder: false,
    },
    {
      name: "Updated by",
      key: "modified_by_first_name",
      selector: (row) =>
        row.modified_by_first_name ? row.modified_by_first_name : "Admin",
      cell: (row) => (
        <div className="created-box">
          <img
            className={row.modified_by_thumbnail ? "image" : "error-img"}
            src={
              row.modified_by_thumbnail ? row.modified_by_thumbnail : dummyPro
            }
            alt="dummy-pro"
          />
          {row.modified_by_first_name ? row.modified_by_first_name : "Admin"}
        </div>
      ),
      sortable: true,
      grow: 2,
      width: "180px",
      reorder: false,
    },
    {
      name: "Last updated",
      key: "modified_date",
      selector: (row) => row?.modified_date,
      cell: (row) => {
        return (
          <div className="date-cell">
            <p>{row?.modified_date}</p>
          </div>
        );
      },
      sortable: true,
      grow: 2,
      width: "180px",
      reorder: false,
    },

    {
      name:
        location.pathname.split("/")[2] === "dashboard" ? "Action" : "Actions",
      key: "action",
      cell: (row, deleteIndex) => (
        <div className="action-wrapper">
          <Tooltip title="View">
            <div className="eye-wrapper" onClick={() => showHandler(row)}>
              <IoEye />
            </div>
          </Tooltip>

          {location.pathname.split("/")[2] === "dashboard" ? (
            <></>
          ) : (
            <Tooltip title="Delete">
              <div
                className="eye-wrapper"
                onClick={() => deleteHandler(row?.id)}
              >
                {" "}
                <RiDeleteBin6Line />
              </div>
            </Tooltip>
          )}
        </div>
      ),
      grow: 0.1,
      minWidth: "130px",
    },
  ];

  const handleSort = (column, sortDirection) => {
    setOrder((prevOrder) => (prevOrder === "desc" ? "asc" : "desc"));
    setSortBy(column?.key);
    setUpdate(!update);
  };

  useEffect(() => {
    // const timeout = setTimeout(() => {
    const scrollContainer = document.querySelector(".my-data-table");

    if (justSearched) {
      scrollContainer.scrollTop = 0;
    }

    const handleScroll = () => {
      if (!scrollContainer || justSearched) return;

      const { scrollTop, scrollHeight, clientHeight } = scrollContainer;
      setSelectedScrollTop(scrollTop);
      if (scrollTop + clientHeight >= scrollHeight - 50) {
        console.log("Reached bottom of DataTable!");
        setReachBottom(true);
        // setScrollComplete(true);
        // setShowLoader(true)
        setJustSearched(false);
        fetchObjectList("next");

        // Remove the scroll listener after reaching bottom
        scrollContainer.removeEventListener("scroll", handleScroll);
      }
    };

    if (scrollContainer && hasMore && !reachBottom) {
      scrollContainer.addEventListener("scroll", handleScroll);
    }

    // Cleanup function
    return () => {
      if (scrollContainer) {
        scrollContainer.removeEventListener("scroll", handleScroll);
      }
    };
    // }, 300);

    // return () => clearTimeout(timeout);
  }, [hasMore, reachBottom, justSearched]);

  const onCloseObject = () => {
    setIsAutoObjectList(true);
    const autoSaveDraftIfExists = async () => {
      const savedDraft = await getAutoSavedFromIndexedDB("collection");
      const savedDigital = await getAutoSavedFromIndexedDB("digital");
      const savedConservation = await getAutoSavedFromIndexedDB("conservation");

      if (savedDraft) {
        setIsSaving({
          collection: true,
        });
        const data = savedDraft;
        data.collection_is_draft = true;
        data.prime_category = data.category;
        data.category = data.sub_category;
        if (data.attribute === null) delete data.attribute;
        if (data.category === "") delete data.category;
        if (data.original_location_room === "")
          delete data.original_location_room;
        if (!data.acquisition_method) delete data.acquisition_method;

        if (data?.transitlunitType) {
          data.transit_location_storage_unit = data.transitlunitType;
        } else if (data?.transitlsystemtype) {
          data.transit_location_storage_system = data.transitlsystemtype;
        } else if (data?.transitlRoom) {
          data.transit_location_room = data.transitlRoom;
        }

        if (data?.originalunitType) {
          data.original_location_storage_unit = data?.originalunitType;
        } else if (data?.originalsystemtype) {
          data.original_location_storage_system = data?.originalsystemtype;
        } else if (data?.originalRoom) {
          data.original_location_room = data?.originalRoom;
        }

        const newEntryImage = data?.ledger_entry_images?.filter(
          (liImage) => liImage?.entry_image
        );
        const newDimension = data?.dimensions?.filter(
          (liDimens) => liDimens?.dimension_name || liDimens?.dimension_value
        );

        data.ledger_entry_images = newEntryImage;
        data.dimensions = newDimension;

        if (
          data?.original_location_room &&
          data?.height &&
          data?.width &&
          data?.depth &&
          data?.reference_image &&
          data?.material &&
          data?.object_name
        ) {
          data.collection_is_draft = false;
        } else {
          data.collection_is_draft = true;
        }

        createObject(data)((res) => {
          if (res?.status) {
            setIsSaving({
              collection: false,
            });
            setUpdate(!update);
            const assignValue = data.assignValue;

            if (assignValue) {
              const newAssignValue = assignValue.id
                ? assignValue
                : { ...assignValue, id: res?.data?.id };
              assignUser(newAssignValue)((response) => {
                if (response?.status) {
                  setIsSaving({
                    collection: false,
                  });
                  setUpdate(!update);
                }
              });
            }
          } else {
            setIsSaving({
              collection: false,
            });
            setUpdate(!update);
          }
        });

        await clearAutoSavedFromIndexedDB("collection");
      } else if (savedDigital) {
        setIsSaving({
          digital: true,
        });

        const digitalData = savedDigital;

        if (digitalData?.object_id) {
          const trimmedImages = [...digitalData.images];
          trimmedImages.pop();
          digitalData.images = trimmedImages;
        }

        const newImageWithIndex = digitalData.images?.map(
          (liImage, liIndex) => ({
            ...liImage,
            index: liIndex,
            image_changed: liImage?.image_changed === true ? true : false,
          })
        );

        if (digitalData?.acquisition_method === "") {
          delete digitalData?.acquisition_method;
        }

        if (digitalData.images) {
          digitalData.images = newImageWithIndex.filter(
            (image) => image.images !== ""
          );
        }

        // digitalData.images = newImageWithIndex
        delete digitalData.tags;
        delete digitalData.dimensions;
        delete digitalData.function_or_usages;
        if (digitalData.object_id) {
          ////This code is to exclude glb data before giving into create object api/////
          const excludeKeys = [
            "object_id",
            "file",
            "image_id",
            "url",
            "image_position",
            "index",
            "image_changed",
          ];
          const createApiData = Object.fromEntries(
            Object.entries(digitalData).filter(
              ([Key]) => !excludeKeys.includes(Key)
            )
          );
          createObject(createApiData)((response) => {
            if (response?.status) {
              if (digitalData.assignValue) {
                assignUser(digitalData.assignValue)((response) => {
                  if (response?.status) {
                  }
                });
              }
            }
          });
          const formData = new FormData();

          formData.append("object_id", digitalData.object_id);
          if (digitalData?.file) {
            formData.append("file", digitalData?.file);
          }
          if (digitalData?.image_id) {
            formData.append("image_id", digitalData?.image_id);
          }
          if (digitalData?.url) {
            formData.append("url", digitalData?.url);
          }
          formData.append("image_position", digitalData?.image_position);
          formData.append("index", digitalData?.index);
          formData.append("image_changed", digitalData?.image_changed);

          createGlb(formData)((response) => {
            if (response?.status) {
              setIsSaving({
                digital: false,
              });
              setUpdate(!update);
            } else {
              setIsSaving({
                digital: false,
              });
              setUpdate(!update);
            }
          });
        } else {
          createObject(digitalData)((response) => {
            if (response?.status) {
              if (digitalData.assignValue) {
                assignUser(digitalData.assignValue)((response) => {
                  if (response?.status) {
                    setIsSaving({
                      digital: false,
                    });
                    setUpdate(!update);
                  } else {
                    setIsSaving({
                      digital: false,
                    });
                  }
                });
              } else {
                setIsSaving({
                  digital: false,
                });
                setUpdate(!update);
              }
            } else {
              setIsSaving({
                digital: false,
              });
              setUpdate(!update);
            }
          });
        }

        await clearAutoSavedFromIndexedDB("digital");
      } else if (savedConservation) {
        setIsSaving({
          conservation: true,
        });

        const conservationData = savedConservation;

        if (!conservationData.stability) {
          delete conservationData.stability;
        }
        const filteredProposedTreatment =
          conservationData?.proposed_treatment.filter((li) => {
            const hasImportantData = li?.degradation || li?.temp_id; // Check if degradation or temp_id exists

            const noDataPropose =
              li?.step &&
              li?.action === "" &&
              li?.is_completed === false &&
              li?.task === "" &&
              li?.status === "" &&
              !hasImportantData;

            return !noDataPropose;
          });

        const filteredInvestigationTreatment =
          conservationData?.investigation_details?.filter((li) => {
            const noInvestigation =
              (li?.invasive_or_non_vasive === false ||
                li?.invasive_or_non_vasive === true) &&
              li?.result === "" &&
              li?.sample_details === "" &&
              li?.investigation_name === "";

            return !noInvestigation;
          });

        const filterGraphicaldescription =
          conservationData?.graphical_represenatation?.filter(
            (filterItem) => filterItem?.image
          );

        conservationData.graphical_represenatation = filterGraphicaldescription;
        conservationData.investigation_details = filteredInvestigationTreatment;
        conservationData.proposed_treatment = filteredProposedTreatment;
        conservationData.conservation_is_draft = true;

        objectConservationCreation(conservationData)((response) => {
          if (response?.status) {
            if (
              conservationData?.stability ||
              conservationData?.is_emergency
              // &&
              // conservationData?.remarks
            ) {
              const hasProposedTreatmentWithoutStep =
                conservationData?.proposed_treatment?.some((treatment) =>
                  ["Started", "In progress", "Done"].includes(treatment.status)
                );

              const conservationStatus = hasProposedTreatmentWithoutStep
                ? "in_conservation"
                : "in_conditional_assessment";

              const statusValues = {
                id: conservationData.id,
                conservation_status: conservationStatus,
              };

              objectConservationStatus(statusValues)((response) => {
                if (response?.status) {
                  setIsSaving({
                    conservation: false,
                  });
                  setUpdate(!update);
                } else {
                  setIsSaving({
                    conservation: false,
                  });
                  setUpdate(!update);
                }
              });
              // }
            } else {
              setIsSaving({
                conservation: false,
              });
            }
            if (conservationData.assignValue) {
              assignUser(conservationData.assignValue)((response) => {
                if (response?.status) {
                  setIsSaving({
                    conservation: false,
                  });
                } else {
                  setIsSaving({
                    conservation: false,
                  });
                }
              });
            }
          } else {
            setIsSaving({
              conservation: false,
            });
          }
        });

        await clearAutoSavedFromIndexedDB("conservation");
      }
    };
    autoSaveDraftIfExists();
    setShowObjectDetail({
      id: "",
      show: false,
    });
  };
  const redirectCondition = (value) => {
    if (checkPermission("collection_change_object")) {
      return `/${
        userData.museum_name
          ? userData.museum_name.split(" ").join("_")
          : "Nefos"
      }/${EDIT_OBJECT}/${value?.id}`;
    } else if (checkPermission("photogrophy_change_object")) {
      return `/${
        userData.museum_name
          ? userData.museum_name.split(" ").join("_")
          : "Nefos"
      }/${EDIT_PHOTOGRAPHY}/${value?.id}`;
    } else if (checkPermission("conservation_change_object")) {
      return `/${
        userData.museum_name
          ? userData.museum_name.split(" ").join("_")
          : "Nefos"
      }/${ADD_CONSERVATION}/${value?.id}`;
    } else {
      return `/${
        userData.museum_name
          ? userData.museum_name.split(" ").join("_")
          : "Nefos"
      }/${ADMIN_DETAIL}/${value?.id}`;
    }
  };

  return (
    <div>
      <div className="table-wrapp" style={{ width: "100%" }}>
        <Drawer
          open={showObjectdetail.show}
          onClose={() => onCloseObject()}
          direction="right"
          className="bla bla bla"
          style={{ width: "80%", overflowX: "hidden" }}
          enableOverlay={false}
        >
          {showObjectdetail.collection && (
            <ObjectAdd
              isAutoObjectList={isAutoObjectList}
              onCloseObject={onCloseObject}
              objectId={showObjectdetail.id}
              fromList={showObjectdetail.show}
            />
          )}
          {showObjectdetail.digital && (
            <Objectphotographydetails
              onCloseObject={onCloseObject}
              objectId={showObjectdetail.id}
              fromList={showObjectdetail.show}
            />
          )}
          {showObjectdetail.conservation && (
            <Objectconsadd
              onCloseObject={onCloseObject}
              objectId={showObjectdetail.id}
              fromList={showObjectdetail.show}
            />
          )}
        </Drawer>
        <Modal size="xl" show={showDetail} onHide={hideHandler}>
          <Modal.Header className="detail-view-header" closeButton>
            <Modal.Title
              style={{
                maxWidth: "440px",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {details?.object_name}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="detail-view-modal d-flex">
              <div className="detail-image">
                <div
                  style={{
                    height: "409px",
                    width: "300px",
                    border: detailImage
                      ? "1px solid rgb(238, 238, 238)"
                      : "none",
                    padding: "5px",
                    borderRadius: "5px",
                  }}
                >
                  <img
                    style={{
                      height: "100%",
                      width: "100%",
                      objectFit: "contain",
                    }}
                    className={detailImage ? "thumb-img" : "error-img"}
                    onError={(e) => (e.currentTarget.src = dummyImage)}
                    src={detailImage ? detailImage : dummyImage}
                    alt="detail-image"
                  />
                </div>
                <div className="create-card-object">
                  <div className="create-by">
                    <h6>Created by</h6>
                    <p>
                      {" "}
                      {details?.created_by_name
                        ? details?.created_by_name
                        : "Admin"}
                    </p>
                  </div>
                  <div className="create-at">
                    <h6>Created at</h6>
                    <p>{showDate}</p>
                  </div>
                </div>
              </div>
              <div className="detail-mid">
                <div className="detail-descr" style={{ height: "490px" }}>
                  <div className="descr-title">
                    <h5
                      style={{
                        maxWidth: "440px",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      {details?.object_name}
                    </h5>
                    {detaildescr && (
                      <p
                        style={{ overflow: "auto", height: "470px" }}
                        className="pl-5"
                      >
                        {detaildescr}
                      </p>
                    )}
                  </div>
                  {!detaildescr && (
                    <p
                      className="descr-not-found"
                      style={{ alignItems: "flex-start" }}
                    >
                      Description not added yet! Please tell us more...
                    </p>
                  )}
                </div>
              </div>
            </div>
          </Modal.Body>
        </Modal>
        <DataTable
          className="my-data-table"
          columns={columns}
          fixedHeaderScrollHeight="68vh"
          data={data}
          striped={true}
          center={true}
          highlightOnHover
          fixedHeader
          onSort={handleSort}
          sortServer
          selectableRowsComponentProps={selectProps}
          onSelectedRowsChange={checkedRowHandler}
          onChangePage={(page) => {
            setPage(page);
            setUpdate(!update);
          }}
          onChangeRowsPerPage={(perPage, pageNumber) => {
            setLimit(perPage);
            setUpdate(!update);
            setPage(pageNumber);
          }}
          progressPending={pending}
          progressComponent={<Loader />}
          customStyles={queueDatatableCustomStyles}
        />
      </div>
      {reachBottom && (
        <div style={{ display: "flex", justifyContent: "center" }}>
          {!pending &&
            (hasMore ? (
              <p
                style={{ textAlign: "center", padding: "1rem", color: "gray" }}
              >
                <b>Loading more...</b>
              </p>
            ) : (
              reachBottom &&
              data?.length > 0 && (
                <p
                  style={{
                    textAlign: "center",
                    padding: "1rem",
                    color: "gray",
                  }}
                >
                  <b>You have seen it all</b>
                </p>
              )
            ))}
        </div>
      )}
    </div>
  );
};

export default TransitObjectTable;
